import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth-routes/admin/deliverableOneOffCostItems')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/deliverableOneOffCostItem' })
  },
})
